
import { Component, OnInit, Inject } from '@angular/core';
import { identifierModuleUrl } from '@angular/compiler';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DgHubClientService, SettingsRequest, Settings, ViewSettingsReq, Views, StorePriceRangeReq } from 'src/app/Services/dg-hub-client.service';
import { DrawingService } from 'src/app/Services/DrawingService';
import { CookiesService } from 'src/app/Services/cookieService';
import { StoreScaleRangeReq } from '../../Services/dg-hub-client.service';
import { ViewsEditDialogComponent } from '../views-edit/views-edit.component';

@Component({
  selector: 'app-views-dialog',
  templateUrl: './views.component.html',
  styleUrls: ['./views.component.css']
})


export class ViewsDialogComponent implements OnInit {


  private _views: Views[];
  public get views(): Views[] {
    return this._views;
  }
  public set views(value: Views[]) {
    this._views = value;
  }

  private _disabled: boolean = true;
  public get disabled(): boolean {
    return this.settingsForm.controls["viewName"].value==null || this.settingsForm.controls["viewName"].value=='';
  }
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(
    public dialogRef: MatDialogRef<ViewsDialogComponent>,
    private fb: FormBuilder,
    public dgCLientService:DgHubClientService,
    private cookieService: CookiesService,
    public drawingService:DrawingService,
    public dialog: MatDialog,
    ) {

  }

  settingsForm = this.fb.group({
    viewName: [null],
    selectedview: [null],
  })

  ngOnInit() {

    this.dgCLientService.GetViewsList().then(v=>{
      this.views = v.views
    })


  }

  loadViewsList()
  {
    this.dgCLientService.GetViewsList().then(v=>{
      this.views = v.views

    })
  }


  onConfirm(): void {

    this.drawingService.saveOrUpdateView(this.settingsForm.controls["viewName"].value)
      this.dialogRef.close();

  }


  onDismiss(): void {
    // Close the dialog, return false


    this.dialogRef.close(false);
  }

  showEdits()
  {
    const dialogRef = this.dialog.open(ViewsEditDialogComponent, {
      width: 'auto',
      height: 'auto',
      maxHeight: window.innerHeight - 30 +'px',
      maxWidth:'100vw',
      minWidth:'300px',
    });
  }
}
